<script>
  import { onMount } from "svelte";
  import Chart from "./Chart.svelte";
  import loadingData from "../data/loadingData";
  import { webfetch } from "../../../svelte_utils";
  /**
   * @typedef {Object} Props
   * @property {string} [url]
   * @property {string} [damID]
   * @property {any} parent
   */

  /** @type {Props} */
  let { url = "", damID = "0", parent } = $props();
  let loading = false;
  let error = $state(void 0);
  let data = $state(void 0);
  let loadingObj = $derived(loadingData ? JSON.parse(loadingData) : []);

  async function getData() {
    try {
      let res = await webfetch(url);
      data = res;
    } catch (err) {
      error = "temporarily unavailable";
    }
  }

  onMount(async () => {
    getData();
  });
</script>

​​
<div class="wc-dam-cap__data">
  {#if data}
    <Chart {data} {damID} {parent} />
  {:else if error}
    <Chart data={loadingObj} {parent} />
    <div class="wc-dams__overlay wc-dams__overlay--error">
      <pre>{error}</pre>
    </div>
  {:else}
    <Chart data={loadingObj} {parent} />
  {/if}
</div>
